import axios from 'axios'
import NProgress from 'nprogress'
import Router from '@/router'
import Vue from 'vue'
import 'nprogress/nprogress.css'
import Notification from 'element-ui/lib/notification';

axios.defaults.timeout = 10000;
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.baseURL = 'http://rap2api.taobao.org/app/mock/122376/';
//axios.defaults.baseURL = 'https://localhost/';
axios.defaults.baseURL = '/api/';

//http request 拦截器
axios.interceptors.request.use(function(config) {
	NProgress.start();

	config.data = JSON.stringify(config.data);
	config.headers = {
		'content-Type': 'application/json;charset=UTF-8'
	}
	let token = sessionStorage.getItem('token');
	if (!token) {
		token = "";
	}
	//config.headers.Authorization = token;
	config.headers.TOKEN = token;

	if (config.method === 'post') {}
	return config;

}, function(error) {
	console.error('错误的传参');
	return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(function(res) {
	let errCode = res.data.errorCode;
	NProgress.done();
	if (errCode == '1401' || errCode == '1403') {
		if (Router.currentRoute.path == "/") {
			return;
		}
		sessionStorage.clear();
		const path = window.location.pathname;
		const parts = path.split('/');
		const code = parts[1];
		console.log(code)

		Router.push({
			path: '/' + code + "/login",
			query: {
				errorMessage: res.data.message
			}
		}).catch(err => {
			if (err.name !== 'NavigationDuplicated') {
			}
		});;
		return Promise.reject(res);

	} else if (errCode == '1404') {
		alert(res.data.message);
		return Promise.reject(res);
	} else {
		if(res.config.responseType=="arraybuffer"){
			return res;
		}
		if (res.data.errorCode === '0000') {
			return res;
		}
		if (res.config.error) {
			res.config.error(res)
		} else {
			Notification.error({
				title: '系统提示',
				message: res.data.message,
				type: 'success'
			});
			const error = new Error(res.data.message);
			error.response = res;
			throw error;
		}
	}
}, function(error) {
	return Promise.reject(error);
});

export default axios;


//////////////////
// WEBPACK FOOTER
// ./config/http.js
// module id = null
// module chunks = 